import api from "../../api.js";

export async function fetchSupplierRatings() {
  const res = await api.get("/api/supplier-ratings");
  return res.data?.data || [];
}

export async function createSupplierRating(payload) {
  const res = await api.post("/api/supplier-ratings", payload);
  return res.data?.data;
}

export async function updateSupplierRating(id, payload) {
  const res = await api.put(`/api/supplier-ratings/${id}`, payload);
  return res.data?.data;
}
